import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import * as T_T from 'cryface';
import { WechatDelegate } from '../../services/DataDelegate/WechatDelegate/wechat.delegate';
import { SelinaShare } from './social.share.manager';
// @ts-ignore
import VueQRCodeComponent from 'vue-qrcode-component';
import { CommonConfig } from '../../configs/config.common';

@Component({
   components: {
      'qr-code': VueQRCodeComponent
   }
})
export default class SocialShareComponent extends Vue {
   public title: string = 'SocialShareComponent';

   public wechat = new WechatDelegate();

   public configs = new CommonConfig();

   public reset = true;

   public hackReset = false;

   public selinaSocialShare: SelinaShare.SelinaShareManager = new SelinaShare.SelinaShareManager();

   @Prop({
      default: true
   })
   public headerShow!: boolean;

   @Watch('$store.state.socialShare.config', { immediate: true, deep: true })
   public async onDataInput(val: any, oldVal: any) {
      if (T_T.simpleDetect(this.$store.state.socialShare.config)) {
         this.selinaSocialShare.setConfig(this.$store.state.socialShare.config);
      }
   }

   public async mounted() {
   }

   public getRifoDesign(str: string) {
      return `${this.configs.rifoDesignAssetsUrl}${str}`;
   }
}
